export enum LemonatorNakyma {
  // Kirjanpito
  KIRJANPITO = 'kirjanpito',

  // Lemonaid
  TOSITTEET_LATAA = 'tositteet-lataa',
  TOSITTEET_SELAA = 'tositteet-selaa',
  LASKUT_SELAA = 'laskut-selaa',
  LASKU_ASIAKKAAT_SELAA = 'lasku-asiakkaat-selaa',
  TUOTTEET_SELAA = 'tuotteet-selaa',
  OSTOLASKUT_SELAA = 'ostolaskut-selaa',
  TOIMITTAJAT_SELAA = 'toimittajat-selaa',
  LASKUT_TOISTUVAT = 'laskut-toistuvat',
  KAYTTAJAT = 'kayttajat',
  MAKSUTAVAT = 'maksutavat',
  AINEISTON_LATAUS = 'aineiston-lataus',
  KIRJANPIDON_ULKOPUOLISET_VAHENNYKSET = 'kirjanpidon-ulkopuoliset-vahennykset',
  LASKUASETUKSET = 'laskuasetukset',

  // Asetukset
  ASIAKASTIEDOT = 'asiakastiedot',
  TUNTEMISTIEDOT = 'tuntemistiedot',
  KIRJANPITOTIEDOT = 'kirjanpitotiedot',
  SISAINEN_ARKISTO = 'sisainen-arkisto',
  LASKUTUS = 'laskutus',
  SOPIMUKSET = 'sopimukset',
  HOLVI_IMPORT = 'holvi-import',
  AJASTETUT_TYOT = 'ajastetut-tyot',
  LATAUS_TYOT = 'lataus-tyot',

  // Asiakaskohtainen yllapito
  PANKKIYHTEYDET = 'pankkiyhteydet',
  TILITAPAHTUMAT = 'tilitapahtumat',
  PAIVASALDOT = 'paivasaldot',
  RESKONTRA_DEBUG = 'reskontra-debug',
  APIX_LASKUT = 'apix-laskut',
  KIRJANPIDON_LAHETYKSET = 'kirjanpidon-lahetykset',
  VERONMAKSU = 'veronmaksu',
  ALUSTA_KIRJANPITO = 'alusta-kirjanpito',
  /** @deprecated korvattu TUONNIT-näkymällä. Säilytetään enumissa jotta jo myönnetyt vanhat oikeudet eivät hajota tarkistuksia. */
  ALKUSALDO_IMPORT = 'alkusaldo-import',
  /** @deprecated korvattu TUONNIT-näkymällä. Säilytetään enumissa jotta jo myönnetyt vanhat oikeudet eivät hajota tarkistuksia. */
  TUOTE_IMPORT = 'tuote-import',
  TUONNIT = 'tuonnit',
  YHTEISOMYYNTI_ILMOITUKSET = 'yhteisomyynti-ilmoitukset',

  // Yllapito (ei asiakaskohtainen)
  YLLAPITO_RAPORTIT = 'yllapito-raportit',
  YLLAPITO_MASSAMUIKKARIT = 'yllapito-massamuikkarit',
  YLLAPITO_PAATILIKARTTA = 'yllapito-paatilikartta',
  YLLAPITO_INTEGRAATIOT_VEROHALLINTO = 'yllapito-integraatiot-verohallinto',
  YLLAPITO_INTEGRAATIOT_HOLVI = 'yllapito-integraatiot-holvi',
  YLLAPITO_KIRJANPITAJAT = 'yllapito-kirjanpitajat',
  YLLAPITO_TIIMIT = 'yllapito-tiimit',
  YLLAPITO_TIIMIKOKONAISUUDET = 'yllapito-tiimikokonaisuudet',
  YLLAPITO_TILINTARKASTAJAT = 'yllapito-tilintarkastajat',
  YLLAPITO_TAGIT = 'yllapito-tagit',
  YLLAPITO_SOPIMUKSET = 'yllapito-sopimukset',
  YLLAPITO_YHTEISOMYYNTILASKUT = 'yllapito-yhteisomyyntilaskut',
  YLLAPITO_PANKKIYHTEYDET = 'yllapito-pankkiyhteydet',
  YLLAPITO_AJASTETUT_TYOT = 'yllapito-ajastetut-tyot',
  YLLAPITO_LOGIT = 'yllapito-logit',
  YLLAPITO_TILASTOJEN_SIIRTO = 'yllapito-tilastojen-siirto',
  YLLAPITO_PUSH_ILMOITUKSET = 'yllapito-push-ilmoitukset',
  YLLAPITO_LLM_TYOKALUT = 'yllapito-llm-tyokalut',
  YLLAPITO_SAHKOPOSTIPOHJAT = 'yllapito-sahkopostipohjat',
  YLLAPITO_LEMONAID_VIESTIT = 'yllapito-lemonaid-viestit',
  YLLAPITO_MONIYRITYSTUET = 'yllapito-moniyritystuet',

  // Koti
  ASIAKASHAKU = 'asiakashaku',
  JAETTAVAT_ASIAKKAAT = 'jaettavat-asiakkaat',
}
